/* SpawnAnything — Mutatoren (Phase D2, variant "Karte mit Schaltern", 02.10.2026): odd rules for a battle, one card in
   the world options. Moon gravity and chain explosions live in the sim (setup field `mutators`, sim.worker.js);
   mini/giant armies and sprint change the troops' values before the sim gets them (cfg size, stats speed), so
   multiplayer (the host's values), replays and the bet pool stay consistent. Off in bets, campaign, daily battle and
   defence (their balance was measured without). Nothing set = the setup message has no `mutators` field. */

const KEY = 'aw-mutators';
export const MUT_DEFAULT = { moon: false, chain: false, size: 'normal', sprint: false };
export const SIZE_F = { normal: 1, mini: 0.5, riesen: 2 };
export const MOON_GRAV = 0.35, SPRINT_F = 1.6;

/** state -> sim setup field ({} when nothing changes the sim) */
export function mutatorMsg(m) {
  const o = {};
  if (m.moon) o.grav = MOON_GRAV;
  if (m.chain) o.chain = true;
  return Object.keys(o).length ? { mutators: o } : {};
}
/** troop config before the army is built (size) */
export const mutateCfg = (m, c) => (m.size !== 'normal' && SIZE_F[m.size] ? { ...c, size: Math.min(20, (c.size || 1) * SIZE_F[m.size]) } : c);
/** stats after the army is built (speed) */
export function mutateStats(m, st) { if (m.sprint) st.speed *= SPRINT_F; return st; }
export const anyMutator = m => !!(m.moon || m.chain || m.sprint || m.size !== 'normal');
export function mutatorText(m) {
  return [m.moon && 'Mond-Schwerkraft', m.chain && 'Kettenexplosionen', m.size === 'mini' && 'Mini-Armeen', m.size === 'riesen' && 'Riesen-Armeen', m.sprint && 'Sprint für alle'].filter(Boolean).join(', ');
}

/**
 * host: { active() -> bool (false in bets / campaign / daily / defence), onChange() (re-setup) }
 */
export function createMutators(host) {
  let m = { ...MUT_DEFAULT };
  try { const s = JSON.parse(localStorage.getItem(KEY)); if (s && typeof s === 'object') m = { ...m, moon: !!s.moon, chain: !!s.chain, sprint: !!s.sprint, size: SIZE_F[s.size] ? s.size : 'normal' }; } catch { /* defaults */ }
  const save = () => { try { localStorage.setItem(KEY, JSON.stringify(m)); } catch { /* private mode */ } };
  const cur = () => (host.active() ? m : MUT_DEFAULT);
  let syncs = [];
  function set(k, v) { m = { ...m, [k]: v }; save(); syncs.forEach(f => f()); host.onChange(); }

  /** the card in the world options (worldOptions.addCard) */
  function mount(addCard) {
    const rows = document.createElement('div'); rows.className = 'mut-rows';
    const seg = (key, label, opts) => {
      const r = document.createElement('div'); r.className = 'mut-row';
      r.innerHTML = `<span>${label}</span><div class="seg" role="group" aria-label="${label}">${opts.map(([v, t]) => `<button type="button" data-v="${v}">${t}</button>`).join('')}</div>`;
      const btns = r.querySelectorAll('[data-v]'), val = v => (v === 'true' ? true : v === 'false' ? false : v);
      const sync = () => btns.forEach(b => b.setAttribute('aria-pressed', String(val(b.dataset.v) === m[key])));
      btns.forEach(b => b.addEventListener('click', () => set(key, val(b.dataset.v))));
      syncs.push(sync); sync();
      return r;
    };
    const onOff = [['true', 'An'], ['false', 'Aus']];
    rows.append(
      seg('moon', 'Mond-Schwerkraft', onOff),
      seg('chain', 'Kettenexplosionen', onOff),
      seg('size', 'Größe', [['mini', 'Mini'], ['normal', 'Normal'], ['riesen', 'Riesen']]),
      seg('sprint', 'Sprint für alle', onOff),
    );
    const note = document.createElement('p'); note.className = 'sdesc mut-note';
    note.textContent = 'Nicht in Wetten, Kampagne, Tagesschlacht und Verteidigung.';
    return addCard('ti-flask', 'Mutatoren', 'Verrückte Regeln für die nächste Schlacht.', [rows, note], 'wo-mut');
  }
  return {
    mount,
    msg: () => mutatorMsg(cur()),
    cfg: c => mutateCfg(cur(), c),
    stats: st => mutateStats(cur(), st),
    get any() { return anyMutator(cur()); },
    text: () => mutatorText(cur()),
    state: () => ({ ...m }),
  };
}
